import React, { useMemo } from 'react';

import {
	useClassNames,
} from '@common';

import './DefaultTh.scss';

interface DefaultThProps extends React.ThHTMLAttributes<HTMLTableHeaderCellElement> {
	minWidth?: string,
	width?: string,
}

function DefaultTh(props: DefaultThProps): JSX.Element {
	const {
		className,
		children,
		minWidth,
		width,
		style,
		...thProps
	} = props;

	const thStyles = useMemo(() => ({
		...style,
		minWidth,
		width,
	}), [style, minWidth, width]);

	const classes = useClassNames('table__th', 'table__cell', className);

	return (
		<th className={classes} style={thStyles} {...thProps}>
			{children}
		</th>
	);
}

const MemoisedDefaultTh = React.memo(DefaultTh);

export {MemoisedDefaultTh as DefaultTh};